import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Organization, OrganizationRequest, OrganizationUsersRequest } from '../models/organization.model';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {
  private http = inject(HttpClient);
  private readonly organizationsApiUrl = `${environment.apiBaseUrl}/organizations`;

  getAll(): Observable<Organization[]> {
    return this.http.get<Organization[]>(this.organizationsApiUrl);
  }

  getById(id: number): Observable<Organization> {
    return this.http.get<Organization>(`${this.organizationsApiUrl}/${id}`);
  }

  create(request: OrganizationRequest): Observable<Organization> {
    return this.http.post<Organization>(this.organizationsApiUrl, request);
  }

  update(id: number, request: OrganizationRequest): Observable<Organization> {
    return this.http.put<Organization>(`${this.organizationsApiUrl}/${id}`, request);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.organizationsApiUrl}/${id}`);
  }

  addUsers(id: number, request: OrganizationUsersRequest): Observable<Organization> {
    return this.http.post<Organization>(`${this.organizationsApiUrl}/${id}/users`, request);
  }

  removeUser(id: number, userId: string): Observable<void> {
    return this.http.delete<void>(`${this.organizationsApiUrl}/${id}/users/${userId}`);
  }
}
